<template>
    <div>
        <app-header>
          <template v-slot:actions>
            <button type="button" class="btn btn-primary mt-2 mt-xl-0" v-c-modal:clientModal="{}">
              <i class="far fa-plus"></i> Client
            </button>
          </template>
        </app-header>
        <div class="container my-5">

          <h2>Clients</h2>
          <clients-list-filters v-model="params" />

          <c-data-list ref="dataList" :items="clients" @load="loadNextPage">
            <template v-slot:columns>
              <div class="col-sm-6 col-xl-4">
                  Name
              </div>
              <div class="col-sm-6 col-xl-4">
                  Phone
              </div>
              <div class="col-sm-6 col-xl-4">
                  Updated
              </div>
            </template>
            <template v-slot:default="slotProps">
              <router-link tag="a" :to="{ name: 'clients.timeline', params: { 'client_id': slotProps.item.id }}" class="row">
                <p class="truncate name">{{ slotProps.item.company}}</p>
                <div class="row row-details">
                    <div class="col-sm-6 col-xl-4">
                        <p class="truncate">{{ slotProps.item.firstname }} {{ slotProps.item.surname }}</p>
                    </div>
                    <div class="col-sm-6 col-xl-4">
                        <p class="truncate"><i class="small fal fa-phone" v-show="slotProps.item.phone.length"></i>&nbsp;{{ slotProps.item.phone }}</p>
                    </div>
                    <div class="col-sm-6 col-xl-4">
                        <p class="truncate"><span class="date small">{{ slotProps.item.updated_at | moment("DD/MM/YY") }}</span></p>
                    </div>
                </div>
              </router-link><!-- /.row -->
            </template>
          </c-data-list>

          <client-create-modal ref="clientModal" title="Create Client" :client="newClient" mode="create" @created="clientCreated"></client-create-modal>
        </div>
    </div>
</template>

<script>

    import { isEqual, debounce } from 'lodash'
    import { mapState, mapActions } from 'vuex'
    import { notify } from 'utils'
    import ClientCreateModal from './ClientCreateModal'
    import ClientModel from './../../models/client.js'
    import ClientsListFilters from './ClientsListFilters'
    import { helperComputed, helperMethods } from 'vx/modules/clients'

    export default {
        components: {
            ClientCreateModal,
            ClientsListFilters
        },

        data: function () {
            return {
                params: {},
                sort: 'asc',
                searching: false,
                newClient: new ClientModel(),
            }
        },

        beforeDestroy () {
            this.resetClients()
        },

        mounted () {
          this.$watch('params', async (params, oldParams) => {
            if (isEqual(params, oldParams)) {
              return
            }

            await this.getClients({ params, fresh: true })
          })

          this.getClients({ params: this.params, fresh: true })
        },

        computed: {
            ...helperComputed,

            haveClients () {
                return this.clients.length > 0
            },
        },

        methods: {
            ...helperMethods,

            async clientCreated() {
                // await this.getClients({ params: this.params, fresh: true })
            },

            async loadNextPage (done) {
              const { params } = this

              try {
                await this.getClients({ params })

                done()
              } catch (error) {
                done(true)
              }
            }
        }
    }
</script>

<style scoped>
    .avatar {
        width:45px;
        margin-right:10px;
        float: left;
    }

    .list-sla > li .client p {
        margin-top: 10px;
    }
</style>
